/** @jsx jsx */
import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { typography, fontWeights } from '../../../styles/typography';

const ICON_SIZE = 15;

export const headline = shouldRenderCtaLink =>
  css(typography.effra48, {
    color: colorsPalette.grey,
    fontWeight: fontWeights.medium,
    marginBottom: shouldRenderCtaLink ? 8 : 0,
    position: 'relative',
    [MediaQueries.lgAndUp]: {
      marginBottom: 0,
    },
  });

export const ctaWrapper = css({
  display: 'flex',
  alignItems: 'center',
  [MediaQueries.lgAndUp]: {
    justifyContent: 'flex-end',
  },
});

export const divider = css({
  margin: '32px 0 34px',
  borderTop: `1px solid ${colorsPalette.brown10}`,
  [MediaQueries.lgAndUp]: {
    marginBottom: 40,
  },
});

export const containerMargin = css({
  margin: '64px 0',
  [MediaQueries.md]: {
    margin: '96px 0',
  },
  [MediaQueries.lgAndUp]: {
    margin: '160px 0',
  },
});

export const cardColumnCss = css({
  marginBottom: 24,
  [MediaQueries.lgAndUp]: {
    marginBottom: 40,
  },
});

export const swiperContainer = css({
  position: 'relative',
  '.swiper-wrapper': {
    paddingBottom: 76,
    display: 'flex',
  },
  '.swiper-container': {
    paddingTop: ICON_SIZE + 42,
  },
  '.swiper-button-prev': {
    fontSize: ICON_SIZE,
    marginTop: 0,
    height: ICON_SIZE,
    zIndex: 1,
    position: 'absolute',
    top: 1,
    left: 0,
  },
  '.swiper-button-next': {
    fontSize: ICON_SIZE,
    marginTop: 0,
    height: ICON_SIZE,
    zIndex: 1,
    position: 'absolute',
    top: 1,
    left: ICON_SIZE + 32,
  },
  '.popular-in-this-area-swiper-pagination': {
    top: 1,
    zIndex: 1,
    right: 0,
    position: 'absolute',
    bottom: 'auto',
    width: 'auto',
    left: 'auto',
    '.swiper-pagination-bullet-active': {
      background: colorsPalette.red,
    },
    '.swiper-pagination-bullet': {
      width: 5,
      height: 5,
    },
  },
  '.swiper-slide': {
    height: 'auto',
  },
});
